
import { useContext, useState } from "react";
import { useForm } from "react-hook-form";
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { AuthContext } from "../../context/AuthProvider";
import Usetoken from "../../hooks/Usetoken";

const Login = () => {
    const { register, formState: { errors }, handleSubmit } = useForm();
    const { logIn, sigInwithGoogle } = useContext(AuthContext);
    const [loginerror, setLoginerror] = useState('');
    const [loginUserEmail, setLoginUserEmat] = useState('');
    // const [token] = Usetoken(loginUserEmail);
    const location = useLocation();
    const navigate = useNavigate();
    const from = location.state?.from?.pathname || '/';

    // if (token) {
    //     navigate(from, { replace: true });
    // }

    const handleLogin = data => {
        console.log(data);
        setLoginerror('');
        logIn(data.email, data.password)
            .then(result => {
                const user = result.user;
                console.log(user);
                // setLoginUserEmat(data.email);
                TakeToken(data.email);


            })
            .catch(error => {
                console.error(error.message)
                setLoginerror(error.message)
            });

    }
    const TakeToken = email => {
        fetch(`https://doctor-portal-server-theta.vercel.app/jwt?email=${email}`)
            .then(res => res.json())
            .then(data => {
                if (data.accessToken) {
                    localStorage.setItem('accessToken', data.accessToken);
                    navigate('/')
                }
            })
    }
    const handleGoogleSingIn = () => {
        sigInwithGoogle()
            .then(result => {
                const user = result.user;
                console.log(user);
            })
            .catch(error => console.error(error))
    }

    return (
        <div className='h-[800px]  flex justify-center items-center'>
            <div className=' w-96 p-7'>
                <h2 className='text-center text-4xl'>Login</h2>
                <form onSubmit={handleSubmit(handleLogin)}>


                    <div className="form-control w-full max-w-xs">
                        <label className="label"><span className="label-text">Email</span></label>
                        <input type="text" {...register("email", {
                            required: "Email Address is required"
                        })} className="input input-bordered w-full max-w-xs" />
                        {errors.email && <p className='text-red-600'>{errors.email?.message}</p>}
                    </div>
                    <div className="form-control w-full max-w-xs">
                        <label className="label"> <span className="label-text">Password</span></label>
                        <input type="password" {...register("password", {
                            required: "Password is required",
                            minLength: { value: 6, message: 'Password must be 6 characters or longer' }
                        })} className="input input-bordered w-full max-w-xs" />
                        {errors.password && <p className='text-red-600'>{errors.password?.message}</p>}
                        <label className="label"> <span className="label-text">Forget Password</span></label>

                    </div>
                    <input className='btn btn-accent w-full' value='Login' type="submit" />
                    {loginerror && <p className="text-red-500">{loginerror}</p>}
                </form>
                <p className='text-1xl mt-2'>New to Here ?<Link className='text-secondary' to='/signup'> Create a new Account</Link>
                </p>
                <div className="divider">OR</div>
                <button onClick={handleGoogleSingIn} className='btn btn-outline w-full'>CONTINUE WITH GOOGLE</button>
            </div>
        </div>
    );
};

export default Login;